export var scales = {
    GM: "gm",
    MD: "md",
    SM: "sm",
    XS: "xs"
};
export var variants = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    SWAP: "swap",
    TEXT: "text",
    DANGER: "danger",
    SUBTLE: "subtle",
    SUCCESS: "success",
    LIGHT: "light"
};
